/* eslint-disable import/prefer-default-export */
import { AppThunk } from '../../ThunkTypes';
import {
  updateCurrentPage,
  updateQuotationHistoryPage,
} from '../slice/steppersSlice';

export const setStepper =
  (currentPage: number): AppThunk =>
  (dispatch): void => {
    dispatch(updateCurrentPage(currentPage));
  };

export const setQuotationHistoryStepper =
  (currentPage: number): AppThunk =>
  (dispatch): void => {
    dispatch(updateQuotationHistoryPage(currentPage));
  };
